import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Autoplay, Pagination } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import styles from "../static/styles/Home.module.css";
import weeklyTournamentStyles from "../static/styles/WeeklyTournaments.module.css";
import {
  fetchWeeklyTournaments,
  fetchEslTournaments,
} from "../api/tournaments";
import { fetchDailyGames, listEslGames } from "../api/games";
import { fetchHighlights, fetchGameHighlights } from "../api/highlights";
import { getRewardsList } from "../api/rewards";

import gamezAcad1 from "../static/img/LearnWin/l&w1.png";
import gamezAcad2 from "../static/img/LearnWin/l&w2.png";
import gamezAcad3 from "../static/img/LearnWin/l&w3.png";

import pubgHighlight from "../static/img/Highlights/pubg.png";
import freeFireHighlight from "../static/img/Highlights/freefire.png";
import codHighlight from "../static/img/Highlights/cod.png";

import arrowBackIcon from "../static/img/Home/arrowLeftIcon.svg";
import arrowForwardIcon from "../static/img/Home/arrowRightIcon.svg";
import calendarIcon from "../static/img/Home/calendarIcon.svg";

import pubgImageDummy from "../static/img/Home/pubgDummy.avif";
import pubgWeekly from "../static/img/Home/pubgWeekly.png";

import pubgIcon from "../static/img/DailyGamingTasks/iconPubgDailyTasks.png";
import freeFireIcon from "../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif";

import pubgBg from "../static/img/WeeklyTournaments/pubg.png";
import freefireBg from "../static/img/WeeklyTournaments/freefire.png";
import { jwtDecode } from "jwt-decode";

import pubgImage from "../static/img/DailyGamingTasks/imagePubgGaming.avif";
import apexImage from "../static/img/DailyGamingTasks/imageApexLegendsGaming.avif";
import codImage from "../static/img/DailyGamingTasks/imageCODGaming.avif";
import minecraftImage from "../static/img/DailyGamingTasks/imageMinecraftGaming.avif";
import clashOfClansImage from "../static/img/DailyGamingTasks/imageCOCGaming.avif";
import clashRoyaleImage from "../static/img/DailyGamingTasks/imageCRDaily.avif";
import fortniteImage from "../static/img/DailyGamingTasks/imageFortniteDaily.avif";
import amongUsImage from "../static/img/DailyGamingTasks/imageAmongUsGaming.avif";
import subwaySurfersImage from "../static/img/DailyGamingTasks/imageSubSurfDaily.avif";
import valorantImage from "../static/img/DailyGamingTasks/imageValorantDaily.avif";
import freeFireImage from "../static/img/DailyGamingTasks/imageFreeFireDaily.avif";
import robloxImage from "../static/img/DailyGamingTasks/imageRobloxDaily.avif";
import fifaImage from "../static/img/DailyGamingTasks/imageFifaGaming.avif";
import eightBallPoolImage from "../static/img/DailyGamingTasks/image8BallDaily.avif";

import playstation5Img from "../static/img/Rewards/ps5.png";
import asusRogStrixGoImg from "../static/img/Rewards/Headphone_premium.png";
import asusRogDeltaSCoreImg from "../static/img/Rewards/Headphone_premium.png";
import edifierG1Img from "../static/img/Rewards/g2.png";
import edifierG2Img from "../static/img/Rewards/g2.png";
import asusTufKeyboardImg from "../static/img/Rewards/tufk3rd.png";
import bloodyB760Img from "../static/img/Rewards/b865n.png";
import bloodyB865NImg from "../static/img/Rewards/b865n.png";
import asusGladiusImg from "../static/img/Rewards/gladius3.png";
import asusKerisImg from "../static/img/Rewards/mouse_premium.png";
import pubgImg from "../static/img/Rewards/pubguc.png";
import fortniteImg from "../static/img/Rewards/fbuks.png";
import minecraftImg from "../static/img/Rewards/minecraft.png";
import aimTrainCover from "../static/img/MadeByESL/aimtrain.png";
import aimTrainCoverSmall from "../static/img/MadeByESL/aimtrain.png";
import aimTrainBattle from "../static/img/MadeByESL/aimtrain.png";
import aimTrainRamadan from "../static/img/MadeByESL/aimtrain.png";
import cannonClashCover from "../static/img/MadeByESL/cannonClash.png";
import cannonClashCoverLarge from "../static/img/MadeByESL/cannonClash.png";
import puzzleManiaCover from "../static/img/MadeByESL/puzzleMania.png";
import puzzleManiaCoverLarge from "../static/img/MadeByESL/puzzleMania.png";
import spaceFootballCover from "../static/img/MadeByESL/spaceFootball.png";
import CannonClashInstructions from "../components/CannonClashInstructions";
import PremiumPackagePopup from "../components/PremiumPackagePopup";
import { trackPremiumPopupOpen } from "../utils/analytics";

import playIcon from "../static/img/Highlights/iconPlayArrow.svg";

import weeklyTournamentsImg from "../static/img/Home/weeklyTournsHome.avif";
import codGamingImg from "../static/img/Home/dailyGamingHome.avif";
import playstation5BannerImg from "../static/img/Home/rewardsHome.avif";

import sectionHeaderBg from "../static/img/Home/section_header_1.png";
import heroSectionBg from "../static/img/Home/hero_section.png";

import icPubg from "../static/img/Home/slider_icons/ic_pubg.png";
import icFreeFire from "../static/img/Home/slider_icons/ic_freefire.png";
import icCod from "../static/img/Home/slider_icons/ic_cod.png";
import icApex from "../static/img/Home/slider_icons/ic_apex.png";
import icMinecraft from "../static/img/Home/slider_icons/ic_minecraft.png";
import icSus from "../static/img/Home/slider_icons/ic_sus.png";
import icCoc from "../static/img/Home/slider_icons/ic_coc.png";
import icSubway from "../static/img/Home/slider_icons/ic_subway.png";
import icFortnite from "../static/img/Home/slider_icons/ic_fortnite.png";
import icValorant from "../static/img/Home/slider_icons/ic_valorant.png";
import icRoyale from "../static/img/Home/slider_icons/ic_royale.png";
import icFifa from "../static/img/Home/slider_icons/ic_fifa.png";
import icRoblox from "../static/img/Home/slider_icons/ic_roblox.png";
import icPool from "../static/img/Home/slider_icons/ic_pool.png";

import weeklyTournamentsImgMobile from "../static/img/Home/weeklyTournsHome_Portrait.avif";
import codGamingImgMobile from "../static/img/Home/dailyGamingHome_Portrait.avif";
import playstation5BannerImgMobile from "../static/img/Home/rewardsHome_Portrait.avif";

import bannerHome from "../static/img/Home/Home.avif";
import bannerLearn from "../static/img/Home/learnandwinbanner.avif";
import bannerESL from "../static/img/Home/madebyeslbanner.avif";
import bannerWeekly from "../static/img/Home/tournmamentsbanner.avif";
import bannerRewards from "../static/img/Home/rewardsbanner.avif";
import bannerTasks from "../static/img/Home/tasksbanner.avif";
import bannerHighlights from "../static/img/Home/highlitsbanner.avif";
import bannerAimTrain from "../static/img/Home/aimtrainSpecial.avif";
import { getUserProfile, updateUserProfile } from "../api/profile";
import dummyAvatar from "../static/img/Sidebar/Avatar.png";
import creditIcon from "../static/img/Home/creditIcon.avif";
import zeroEarbuds from '../static/img/Rewards/zeroEarbuds.png';
import zeroHeadphones from '../static/img/Rewards/zeroHeadphones.png';
import zeroWatch from '../static/img/Rewards/zeroWatch.png';

SwiperCore.use([Autoplay, Pagination]);

const getDailyTaskImage = (gameName, isMobile = false) => {
  // Check if screen width is between 500px and 767px for larger Made by ESL images
  const isMediumScreen = window.innerWidth >= 500 && window.innerWidth <= 767;

  switch (gameName.toLowerCase()) {
    case "clash royale":
      return clashRoyaleImage;
    case "call of duty":
      return codImage;
    case "pubg mobile":
      return pubgImage;
    case "minecraft":
      return minecraftImage;
    case "freefire":
      return freeFireImage;
    case "fortnite":
      return fortniteImage;
    case "apex legends":
      return apexImage;
    case "roblox":
      return robloxImage;
    case "among us":
      return amongUsImage;
    case "fifa mobile":
      return fifaImage;
    case "valorant":
      return valorantImage;
    case "subway surfers":
      return subwaySurfersImage;
    case "clash of clans":
      return clashOfClansImage;
    case "8 ball pool":
      return eightBallPoolImage;
    case "aim train":
      return isMediumScreen ? aimTrainCover : aimTrainCoverSmall;
    case "cannon clash":
      return isMediumScreen ? cannonClashCoverLarge : cannonClashCover;
    case "puzzle mania":
      return isMediumScreen ? puzzleManiaCoverLarge : puzzleManiaCover;
    case "space football":
      return spaceFootballCover;
    default:
      return null; // Fallback img..
  }
};

const getGameIcon = (gameName) => {
  switch (gameName.toLowerCase()) {
    case "pubg mobile":
      return pubgIcon;
    case "freefire":
      return freeFireIcon;
    default:
      return null;
  }
};

const getGameBackground = (gameName) => {
  switch (gameName.toLowerCase()) {
    case "pubg mobile":
      return pubgBg;
    case "freefire":
      return freefireBg;
    // Add other games
    default:
      return null;
  }
};

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return { date: "N/A", time: "N/A" };
  const [datePart, timePart, ampm] = dateTimeString.split(" ");
  return {
    date: datePart,
    time: `${timePart} ${ampm}`,
  };
};

function Home({ isJcUser }) {
  const swiperRef = useRef(null);
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activeChip, setActiveChip] = useState("Daily Tasks");

  const chips = [
    "Daily Tasks",
    "Tournaments",
    "Rewards",
    "ESL Games",
    "Learn & Win",
    "Highlights",
  ];

  const sectionRefs = {
    "ESL Games": useRef(null),
    "Daily Tasks": useRef(null),
    Tournaments: useRef(null),
    "Learn & Win": useRef(null),
    Rewards: useRef(null),
    Highlights: useRef(null),
  };

  const handleChipClick = (chip) => {
    setActiveChip(chip);
    const element = sectionRefs[chip]?.current;
    if (element) {
      const headerOffset = 50;

      let scrollContainer = element.parentElement;
      while (scrollContainer) {
        const overflow = window.getComputedStyle(scrollContainer).overflow;
        if (overflow === "auto" || overflow === "scroll") {
          break;
        }
        scrollContainer = scrollContainer.parentElement;
      }

      if (
        !scrollContainer ||
        scrollContainer === document.body ||
        scrollContainer === document.documentElement
      ) {
        scrollContainer = window;
      }

      if (scrollContainer === window) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      } else {
        const elementPosition = element.offsetTop;
        scrollContainer.scrollTo({
          top: elementPosition - headerOffset,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [dailyGamesData, setDailyGamesData] = useState([]);
  const [loadingDailyGames, setLoadingDailyGames] = useState(true);
  const [errorDailyGames, setErrorDailyGames] = useState(null);

  const [weeklyTournamentsData, setWeeklyTournamentsData] = useState([]);
  const [eslTournamentsData, setEslTournamentsData] = useState([]);
  const [loadingWeekly, setLoadingWeekly] = useState(true);
  const [errorWeekly, setErrorWeekly] = useState(null);

  const [highlightsData, setHighlightsData] = useState([]);
  const [loadingHighlights, setLoadingHighlights] = useState(true);
  const [errorHighlights, setErrorHighlights] = useState(null);

  const [gameHighlightsData, setGameHighlightsData] = useState([]);
  const [loadingGameHighlights, setLoadingGameHighlights] = useState(true);
  const [errorGameHighlights, setErrorGameHighlights] = useState(null);

  const [eslGames, setEslGames] = useState([]);
  const [loadingEslGames, setLoadingEslGames] = useState(true);
  const [errorEslGames, setErrorEslGames] = useState(null);

  const [rewardsData, setRewardsData] = useState([]);
  const [loadingRewards, setLoadingRewards] = useState(true);
  const [errorRewards, setErrorRewards] = useState(null);

  const [mainSliderBanners, setMainSliderBanners] = useState([]);
  const [showInstructions, setShowInstructions] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [bio, setBio] = useState("");
  const [profileImage, setProfileImage] = useState(dummyAvatar);
  const [stats, setStats] = useState({
    tournaments: 0,
    completedTasks: 0,
    credits: 0,
    redeemedItems: 0,
  });
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);

  const handleOpenPremiumPopup = (source = "home") => {
    trackPremiumPopupOpen(source);
    setShowPremiumPopup(true);
  };

  const premiumRewards = rewardsData.filter((r) => r.game === null);
  const normalRewards = rewardsData.filter((r) => r.game !== null);

  useEffect(() => {
    document.title = "Home | Jazz Esl";

    const loadWeeklyTournaments = async () => {
      try {
        setLoadingWeekly(true);
        setErrorWeekly(null);
        const [weeklyData, eslData] = await Promise.all([
          fetchWeeklyTournaments(),
          fetchEslTournaments(),
        ]);
        setWeeklyTournamentsData(weeklyData);
        setEslTournamentsData(eslData);
      } catch (err) {
        setErrorWeekly(err.message || "Failed to load tournaments");
      } finally {
        setLoadingWeekly(false);
      }
    };
    loadWeeklyTournaments();
  }, []);

  useEffect(() => {
    const loadRewards = async () => {
      try {
        setLoadingRewards(true);
        setErrorRewards(null);
        const response = await getRewardsList();
        if (response && response.data && Array.isArray(response.data)) {
          //console.log(response.data)
          setRewardsData(response.data);
        } else {
          setRewardsData([]);
        }
      } catch (err) {
        setErrorRewards(err.message || "Failed to load rewards");
      } finally {
        setLoadingRewards(false);
      }
    };
    loadRewards();
  }, []);

  useEffect(() => {
    const loadDailyGames = async () => {
      try {
        setLoadingDailyGames(true);
        setErrorDailyGames(null);
        const data = await fetchDailyGames();
        data.forEach((game) => {
          getDailyTaskImage(game.game, isMobile);
        });
        setDailyGamesData(data);
      } catch (err) {
        setErrorDailyGames(err.message || "Failed to load daily games");
      } finally {
        setLoadingDailyGames(false);
      }
    };
    loadDailyGames();
  }, []);

  useEffect(() => {
    const loadHighlights = async () => {
      try {
        setLoadingHighlights(true);
        setErrorHighlights(null);
        const data = await fetchHighlights();
        setHighlightsData(data);
      } catch (err) {
        setErrorHighlights(err.message || "Failed to load highlights");
      } finally {
        setLoadingHighlights(false);
      }
    };
    loadHighlights();
  }, []);

  useEffect(() => {
    const loadGameHighlights = async () => {
      try {
        setLoadingGameHighlights(true);
        setErrorGameHighlights(null);
        const data = await fetchGameHighlights();
        setGameHighlightsData(data);
      } catch (err) {
        setErrorGameHighlights(err.message || "Failed to load game highlights");
      } finally {
        setLoadingGameHighlights(false);
      }
    };
    loadGameHighlights();
  }, []);

  // ESL games
  useEffect(() => {
    const loadEslGames = async () => {
      try {
        setLoadingEslGames(true);
        setErrorEslGames(null);
        const eslGamesResp = await listEslGames();
        let eslGamesArr = [];
        if (
          eslGamesResp &&
          eslGamesResp.success &&
          eslGamesResp.data &&
          Array.isArray(eslGamesResp.data.eslgames)
        ) {
          eslGamesArr = eslGamesResp.data.eslgames.map((eslGame) => ({
            ...eslGame,
            game: eslGame.game_name,
          }));
        }

        setEslGames(eslGamesArr);
      } catch (err) {
        setErrorEslGames(err.message || "Failed to load ESL games");
      } finally {
        setLoadingEslGames(false);
      }
    };
    loadEslGames();
  }, []);

  useEffect(() => {
    const baseBanners = [
      // {
      //   id: 2,
      //   image: bannerHome,
      //   title: "Home",
      //   navigateTo: "/",
      // },
      {
        id: 3,
        image: bannerLearn,
        title: "Learn & Win",
        navigateTo: "/learn-win",
      },
      {
        id: 4,
        image: bannerESL,
        title: "Made by ESL",
        navigateTo: "/daily-gaming-tasks",
      },
      {
        id: 5,
        image: bannerWeekly,
        title: "Weekly Tournaments",
        navigateTo: "/tournaments",
      },
      {
        id: 6,
        image: bannerRewards,
        title: "Rewards",
        navigateTo: "/rewards",
      },
      {
        id: 7,
        image: bannerTasks,
        title: "Daily Tasks",
        navigateTo: "/daily-gaming-tasks",
      },
      {
        id: 8,
        image: bannerHighlights,
        title: "Highlights",
        navigateTo: "/highlights",
      },
    ];

    // ESL games in top banner
    // const eslGameBanners = eslGames.map((game, idx) => ({
    //   id: `esl-${game.game_unique_id || idx}`,
    //   image: getDailyTaskImage(game.game) || pubgImageDummy,
    //   title: game.game,
    //   buttonText: `Play ${game.game}`,
    //   onClick: () => handleDailyGameClick(game.gameId || game.game_unique_id),
    //   isEsl: true,
    // }));

    setMainSliderBanners([...baseBanners]);
  }, [isMobile, eslGames]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await getUserProfile();

        console.log("PROFILE:", response);

        if (response.success) {
          setUsername(response.username || "");
          setEmail(response.email || "");
          setGender(response.gender?.toLowerCase() || "");
          setBio(response.bio || "");

          setDateOfBirth(
            response.dateOfBirth
              ? response.dateOfBirth.split("-").reverse().join("-")
              : "",
          );

          setProfileImage(response.profileImage || dummyAvatar);

          setStats({
            tournaments: response.total_tournament || 0,
            completedTasks: response.completed_tasks_total || 0,
            credits: response.credits || 0,
            redeemedItems: response.items_redeemed || 0,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchUserProfile();

    window.addEventListener("authComplete", fetchUserProfile);
    return () => window.removeEventListener("authComplete", fetchUserProfile);
  }, []);

  const breakpoints4Slides = {
    0: {
      // Smol Mobile
      slidesPerView: 2,
      spaceBetween: 15,
    },
    320: {
      // Mobile
      slidesPerView: 2.7,
      spaceBetween: 15,
    },
    400: {
      // Whatever
      slidesPerView: 3,
      spaceBetween: 15,
    },
    590: {
      // Whatever
      slidesPerView: 4.7,
      spaceBetween: 15,
    },
    768: {
      // Tablet
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1354: {
      // Desktop
      slidesPerView: 6,
      spaceBetween: 20,
    },
    1400: {
      // Desktop
      slidesPerView: 8,
      spaceBetween: 20,
    },
  };

  const breakpoints3Slides = {
    0: {
      // Mobile
      slidesPerView: 1.4,
      spaceBetween: 15,
    },
    768: {
      // Tablet
      slidesPerView: 1.7,
      spaceBetween: 20,
    },
    1024: {
      // Desktop
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
    1400: {
      // Desktop
      slidesPerView: 3,
      spaceBetween: 20,
    },
  };

  const learnwinBreakPoints = {
    0: {
      slidesPerView: 2,
      spaceBetween: 12,
    },
    320: {
      slidesPerView: 2.5,
      spaceBetween: 12,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  };

  const eslGameBreakpoints = {
    0: {
      slidesPerView: 2,
      spaceBetween: 2,
    },
    608: {
      // Tablet
      slidesPerView: 3,
      spaceBetween: 5,
    },
    1024: {
      // Desktop
      slidesPerView: 4,
      spaceBetween: 5,
    },
  };

  const highlightsBreakPoints = {
    0: {
      slidesPerView: 2,
      spaceBetween: 6, // was 15
    },
    320: {
      slidesPerView: 3.2,
      spaceBetween: 6, // was 15
    },
    400: {
      slidesPerView: 3.5,
      spaceBetween: 6, // was 15
    },
    590: {
      slidesPerView: 4.7,
      spaceBetween: 8, // was 15
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 10, // was 20
    },
    1354: {
      slidesPerView: 6,
      spaceBetween: 10, // was 20
    },
    1400: {
      slidesPerView: 8,
      spaceBetween: 10, // was 20
    },
  };

  const handleDailyGameClick = (gameId, gameName) => {
    if (!gameId) {
      return;
    }
    if (gameName && gameName.toLowerCase() === "cannon clash") {
      navigate("/tournaments");
    } else {
      navigate(`/game-challenges?gameId=${encodeURIComponent(gameId)}`);
    }
  };

  const handleEslGameClick = (gameId, gameName) => {
    if (!gameId) {
      return;
    }
    if (gameName && gameName.toLowerCase() === "cannon clash") {
      navigate("/tournaments");
    } else {
      navigate(`/esl-orignals?gameId=${encodeURIComponent(gameId)}`);
    }
  };

  const handleInstructionsClose = () => {
    setShowInstructions(false);
  };

  const handleShowInstructions = (gameName) => {
    const isCannonClash = gameName && gameName.toLowerCase().includes("cannon");
    if (isCannonClash) {
      setShowInstructions(true);
    }
  };

  const getGameHighlightImage = (gameName) => {
    switch (gameName.toLowerCase()) {
      case "pubg":
      case "pubg mobile":
        return pubgHighlight;
      case "freefire":
        return freeFireHighlight;
      case "call of duty":
        return codHighlight;
      default:
        return pubgImageDummy; // Fallback img..
    }
  };

  const specialTournaments = eslTournamentsData.filter((t) => {
    if (t.is_live !== 1) return false;
    if (t.tourn_mode !== "special") return false;
    // Hide special tournaments for JC users (is_jc === 1)
    if (isJcUser) return false;
    return true;
  });

  const liveEslTournaments = eslTournamentsData.filter((t) => {
    if (t.is_live !== 1) return false;
    if (t.tourn_mode === "special") return false;
    return true;
  });

  return (
    <>
      {/* PROFILE INFO */}
      <div className={styles.homeProfileTab}>
        <div className={styles.homePrfileLeft}>
          <div className={styles.profileAvatarContainer}>
            <img
              src={profileImage || dummyAvatar}
              alt={username}
              className={styles.profileAvatar}
              onClick={() => navigate("/profile")}
              onError={(e) => {
                e.target.src = dummyAvatar;
              }}
            />
          </div>

          <div className={styles.profileInfo}>
            <span className={styles.welcomeText}>Welcome Back</span>
            <h1 className={styles.profileUsername}>
              {(username?.length > 10
                ? `${username.slice(0, 10)}...`
                : username) || "Guest_User"}
            </h1>
          </div>
        </div>

        <div className={styles.homeProfileRight}>
          <img src={creditIcon} className={styles.creditsIcon}></img>
          <div className={styles.creditsInfo}>
            <span className={styles.creditsAmount}>
              {stats.credits.toString().length > 6
                ? `${stats.credits.toString().slice(0, 5)}...`
                : stats.credits.toLocaleString()}
            </span>
            <span className={styles.creditsLabel}>Credits</span>
          </div>
        </div>
      </div>

      {/* FREE PLAN / PREMIUM CARD */}
      {!isJcUser && (
        <div className={styles.freePlanCardWrapper}>
          <div className={styles.freePlanCard}>
            <div className={styles.freePlanLeft}>
              <span className={styles.freePlanBadge}>BASIC</span>
            </div>

            <span className={styles.freePlanText}>
              You're on the basic plan
            </span>

            <button
              type="button"
              className={styles.goPremiumButton}
              onClick={() => handleOpenPremiumPopup("free_plan_card")}
            >
              GO PREMIUM ›
            </button>
          </div>
        </div>
      )}

      {/* MAIN SLIDER */}
      <div className={styles.container}>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          autoplay={{ delay: 4000 }}
          loop={mainSliderBanners.length > 1}
          slidesPerView={isMobile ? 1 : 2.5}
          spaceBetween={1}
          pagination={{
            el: ".tournament-pagination",
            clickable: true,
          }}
          className="tournament-swiper"
        >
          {mainSliderBanners.map((banner) => (
            <SwiperSlide key={banner.id}>
              <div
                className={styles.slideContainer}
                onClick={
                  banner.isEsl
                    ? banner.onClick
                    : banner.navigateTo
                    ? () => navigate(banner.navigateTo)
                    : undefined
                }
                style={{
                  cursor:
                    banner.navigateTo || banner.isEsl ? "pointer" : "default",
                }}
              >
                <div
                  className={styles.slideImage}
                  style={{ backgroundImage: `url(${banner.image})` }}
                />
                <div className={styles.overlay} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* <div className="tournament-pagination"></div> */}
      </div>

      {/* ICON MARQUEE */}
      {/* <div
        className={styles.iconMarquee}
        style={{ backgroundImage: `url(${heroSectionBg})` }}
      >
        <div className={styles.iconMarqueeTrack}>
          {[
            icPubg,
            icFreeFire,
            icCod,
            icApex,
            icMinecraft,
            icSus,
            icCoc,
            icSubway,
            icFortnite,
            icValorant,
            icRoyale,
            icFifa,
            icRoblox,
            icPool,
            icPubg,
            icFreeFire,
            icCod,
            icApex,
            icMinecraft,
            icSus,
            icCoc,
            icSubway,
            icFortnite,
            icValorant,
            icRoyale,
            icFifa,
            icRoblox,
            icPool,
          ].map((icon, index) => (
            <img
              key={index}
              src={icon}
              alt=""
              className={styles.iconMarqueeIcon}
            />
          ))}
        </div>
      </div> */}

      {/* CHIPS */}
      <div className={styles.chipsContainer}>
        {chips.map((chip) => (
          <button
            key={chip}
            className={`${styles.chip} ${
              activeChip === chip ? styles.chipActive : ""
            }`}
            onClick={() => handleChipClick(chip)}
          >
            {chip}
          </button>
        ))}
      </div>

      {/* AIMTRAIN RAMADAN CHAMPIONSHIP */}
      {/* {specialTournaments.length > 0 && (
        <div className={styles.weeklyTasksSection}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionHeaderTop} style={{ backgroundImage: `url(${sectionHeaderBg})` }}>
              <h3 className={styles.sectionHeaderTitle}>AimTrain Ramadan Championship</h3>
            </div>
            <div className={styles.sectionHeaderBottom}>
              <p className={styles.sectionHeaderSubtitle}>Battle for glory and win a PlayStation 5</p>
              <button className={styles.viewAllButton} onClick={() => navigate('/tournaments')}>
                <span>View Details ›</span>
              </button>
            </div>
          </div>
          <Swiper
            breakpoints={breakpoints3Slides}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 3000 }}
            loop={specialTournaments.length > 1}
          >
            {specialTournaments
              .filter(tournament => tournament.status !== 4)
              .map((tournament) => (
                <SwiperSlide key={`special-${tournament.Id || tournament.id}`}>
                  <div
                    className={styles.weeklyTaskCard}
                    onClick={() => navigate('/tournaments')}
                    style={{ cursor: 'pointer' }}
                  >
                    <div
                      className={styles.weeklyTaskImage}
                      style={{
                        backgroundImage: `url(${aimTrainRamadan})`
                      }}
                    >
                      <div className={styles.weeklyTaskDateContainer}>
                        <img src={calendarIcon} alt="calendar" className={styles.dateIcon} />
                        <span className={styles.weeklyTaskDate}>{formatDateTime(tournament.time).date}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      )} */}

      {/* DAILY TASKS */}
      <div
        ref={sectionRefs["Daily Tasks"]}
        className={styles.dailyTasksSection}
      >
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionHeaderTitle}>Gaming Tasks</h3>
          <p className={styles.sectionHeaderSubtitle}>
            Play daily tasks & win extra credits
          </p>
        </div>

        {loadingDailyGames && <div className={styles.loading}>Loading...</div>}
        {errorDailyGames && (
          <div className={styles.error}>Error: {errorDailyGames}</div>
        )}
        {!loadingDailyGames && !errorDailyGames && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={dailyGamesData.length > 4}
          >
            {dailyGamesData.map((game) => {
              const gameImage =
                getDailyTaskImage(game.game, isMobile) || pubgImageDummy;
              return (
                <SwiperSlide key={game.id}>
                  <div
                    onClick={() => handleDailyGameClick(game.gameId)}
                    className={styles.clickableTaskCard}
                    role="button"
                    tabIndex={0}
                    onKeyPress={(e) =>
                      e.key === "Enter" && handleDailyGameClick(game.gameId)
                    }
                  >
                    <div className={styles.dailyTaskCard}>
                      <div className={styles.premiumBadge}>PREMIUM: 1.2x</div>
                      <img
                        src={gameImage}
                        alt={game.game}
                        className={styles.dailyTaskImage}
                      />
                      {/* Bottom info panel */}
                      <div className={styles.taskFooter}>
                        <div className={styles.taskName}>{game.game}</div>

                        <div className={styles.taskPoints}>
                          +{game.points || 15} Credits
                        </div>
                      </div>
                      {/* <span className={styles.notificationBadge}>{task.notificationCount}</span> */}
                    </div>
                    {/* <p className={styles.taskTitle}>{game.game}</p> */}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
        {!isJcUser && (
          <div className={styles.dailyTaskPemiumCard}>
            <div className={styles.dailyTaskPemiumCardLeft}>
              <div className={styles.dailyTaskPemiumCardLeftimage}>
                <p>⚡</p>
              </div>
              <div className={styles.dailyTaskPemiumCardLeftinfo}>
                <h1>YOU ARE LEAVING POINTS BEHIND</h1>
                <p>Premium gives you 1.2x on every task you complete</p>
              </div>
            </div>
            <div className={styles.dailyTaskPemiumCardRight}>
              <button
                onClick={() => handleOpenPremiumPopup("boost_card")}
                className={styles.dailyTaskPemiumCardLeftbuttton}
              >
                BOOST
              </button>
            </div>
          </div>
        )}
      </div>

      {/* WEEKLY TOURNAMENTS */}
      <div
        ref={sectionRefs["Tournaments"]}
        className={styles.weeklyTasksSection}
      >
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionHeaderTitle}>Tournaments</h3>
          <p className={styles.sectionHeaderSubtitle}>Win Big Credits</p>
        </div>

        {!isJcUser && (
          <div className={styles.dailyTaskPemiumCard}>
            <div className={styles.dailyTaskPemiumCardLeft}>
              <div className={styles.dailyTaskPemiumCardLeftimage}>
                <p>🏆</p>
              </div>
              <div className={styles.dailyTaskPemiumCardLeftinfo}>
                <h1>FREE ENTRY - PREMIUM ONLY</h1>
                <p>Basic members pay fees, Premium plays for free</p>
              </div>
            </div>
            <div className={styles.dailyTaskPemiumCardRight}>
              <button
                onClick={() => handleOpenPremiumPopup("unlock_card")}
                className={styles.dailyTaskPemiumCardLeftbuttton}
              >
                UNLOCK
              </button>
            </div>
          </div>
        )}

        {loadingWeekly && <div className={styles.loading}>Loading...</div>}
        {errorWeekly && (
          <div className={styles.error}>Error: {errorWeekly}</div>
        )}
        {!loadingWeekly && !errorWeekly && (
          <Swiper
            breakpoints={breakpoints3Slides}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 3000 }}
            loop={weeklyTournamentsData.length + liveEslTournaments.length > 3}
          >
            {/* {liveEslTournaments
              .filter((tournament) => tournament.status !== 4) // Filter out ended tournaments
              .map((tournament) => {
                const isCannonClash =
                  tournament.tourn_name &&
                  tournament.tourn_name.toLowerCase().includes("cannon");
                const isAimTrain =
                  tournament.tourn_name &&
                  tournament.tourn_name.toLowerCase().includes("aim train");
                return (
                  <SwiperSlide key={`esl-${tournament.Id || tournament.id}`}>
                    <div
                      className={styles.weeklyTaskCard}
                      onClick={() => navigate("/tournaments")}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className={styles.weeklyTaskImage}
                        style={{
                          backgroundImage:
                            tournament.tourn_mode === "special"
                              ? `url(${aimTrainRamadan})`
                              : isCannonClash
                                ? `url(${cannonClashCover})`
                                : isAimTrain
                                  ? `url(${aimTrainBattle})`
                                  : tournament.thumbnail
                                    ? `url(${tournament.thumbnail})`
                                    : "none",
                        }}
                      >
                        {isCannonClash && (
                          <button
                            className={weeklyTournamentStyles.infoButton}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShowInstructions(tournament.tourn_name);
                            }}
                            title="View Tournament Instructions"
                          >
                            <span className={weeklyTournamentStyles.infoIcon}>
                              ?
                            </span>
                            <span className={weeklyTournamentStyles.infoText}>
                              How to Play
                            </span>
                          </button>
                        )}
                        <div className={styles.weeklyTaskDateContainer}>
                          <img
                            src={calendarIcon}
                            alt="calendar"
                            className={styles.dateIcon}
                          />
                          <span className={styles.weeklyTaskDate}>
                            {formatDateTime(tournament.time).date}
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })} */}

            {/* Weekly Tournaments */}
            {weeklyTournamentsData.map((tournament) => {
              const { date } = formatDateTime(tournament.time);
              const gameBgSrc = getGameBackground(tournament.tourn_name);
              const gameIconSrc = getGameIcon(tournament.tourn_name);

              return (
                <SwiperSlide key={`weekly-${tournament.id}`}>
                  <div
                    className={styles.weeklyTaskCard}
                    onClick={() =>
                      navigate(
                        `/join-tournament?tournamentId=${tournament.tourn_id}`,
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className={styles.weeklyTaskImage}
                      style={{
                        backgroundImage: gameBgSrc
                          ? `url(${gameBgSrc})`
                          : "none",
                      }}
                    >
                      {/* {gameIconSrc && <img src={gameIconSrc} alt={tournament.tourn_name} className={styles.weeklyTaskGameIcon} />} */}
                      <div className={styles.weeklyTaskDateContainer}>
                        <img
                          src={calendarIcon}
                          alt="calendar"
                          className={styles.dateIcon}
                        />
                        <span className={styles.weeklyTaskDate}>{date}</span>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      {/* PREMIUM REWARDS */}
      <div ref={sectionRefs["Rewards"]} className={styles.dailyTasksSection}>
        {/* PREMIUM REWARDS */}
        <div className={styles.sectionHeader} style={{ marginTop: "20px" }}>
          <h3 className={styles.sectionHeaderTitle}>Exclusive Rewards</h3>
          <p className={styles.sectionHeaderSubtitle}>Only for premium users</p>
        </div>

        {!loadingRewards && !errorRewards && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={rewardsData.filter((r) => r.game === null).length > 4}
          >
            {rewardsData
              .filter((reward) => reward.game === null)
              .map((reward) => {
                const getRewardImage = (rewardName) => {
                  if (!rewardName) return "";
                  const name = rewardName.toLowerCase();
                  if (name.includes("playstation")) return playstation5Img;
                  if (name.includes("asus rog") && name.includes("headphone"))
                    return asusRogDeltaSCoreImg;
                  if (name.includes("edifier")) return edifierG1Img;
                  if (name.includes("asus") && name.includes("keyboard"))
                    return asusTufKeyboardImg;
                  if (name.includes("bloody")) return bloodyB760Img;
                  if (name.includes("asus rog") && name.includes("mouse"))
                    return asusGladiusImg;
                  if (name.includes("pubg")) return pubgImg;
                  if (name.includes("fortnite")) return fortniteImg;
                  if (name.includes("minecraft")) return minecraftImg;
                  if (name.includes("zero lifestyle headphones")) return zeroHeadphones;
                  if (name.includes("zero lifestyle watch")) return zeroWatch;
                  if (name.includes("zero lifestyle earbuds")) return zeroEarbuds;
                  return "";
                };

                const rewardImage = getRewardImage(reward.name);

                return (
                  <SwiperSlide key={reward.id || reward.name}>
                    <div className={styles.rewardsCard}>
                      {!isJcUser && (
                        <div className={styles.premiumBadge}>🔒 Premium</div>
                      )}

                      <img
                        src={rewardImage}
                        className={styles.rewardsImage}
                        alt={reward.name}
                        onClick={() => {
                          if (isJcUser) {
                            navigate("/rewards");
                          } else {
                            handleOpenPremiumPopup("reward_card");
                          }
                        }}
                        style={{ cursor: "pointer" }}
                      />

                      <div className={styles.rewardsFooter}>
                        <div className={styles.rewardsGame}>
                          {reward.game || ""}
                        </div>
                        <div className={styles.rewardsName}>{reward.name}</div>

                        <div className={styles.rewardsCredits}>
                          {/* <span>CREDITS : </span> */}
                          <span>
                            {reward.credits
                              ? reward.credits.toLocaleString()
                              : "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}
      </div>

      {/* REWARDS */}
      <div ref={sectionRefs["Rewards"]} className={styles.dailyTasksSection}>
        {/* NORMAL REWARDS */}
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionHeaderTitle}>Rewards</h3>
          <p className={styles.sectionHeaderSubtitle}>
            Win Gaming accessories and currencies
          </p>
        </div>

        {!loadingRewards && !errorRewards && (
          <Swiper
            breakpoints={breakpoints4Slides}
            className={styles.dailyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={rewardsData.filter((r) => r.game !== null).length > 4}
          >
            {rewardsData
              .filter((reward) => reward.game !== null)
              .map((reward) => {
                const getRewardImage = (rewardName) => {
                  if (!rewardName) return "";
                  const name = rewardName.toLowerCase();
                  if (name.includes("playstation")) return playstation5Img;
                  if (name.includes("asus rog") && name.includes("headphone"))
                    return asusRogDeltaSCoreImg;
                  if (name.includes("edifier")) return edifierG1Img;
                  if (name.includes("asus") && name.includes("keyboard"))
                    return asusTufKeyboardImg;
                  if (name.includes("bloody")) return bloodyB760Img;
                  if (name.includes("asus rog") && name.includes("mouse"))
                    return asusGladiusImg;
                  if (name.includes("pubg")) return pubgImg;
                  if (name.includes("fortnite")) return fortniteImg;
                  if (name.includes("minecraft")) return minecraftImg;
                  return "";
                };

                const rewardImage = getRewardImage(reward.name);

                return (
                  <SwiperSlide key={reward.id || reward.name}>
                    <div className={styles.rewardsCard}>
                      <img
                        src={rewardImage}
                        className={styles.rewardsImage}
                        alt={reward.name}
                        onClick={() => navigate("/rewards")}
                        style={{ cursor: "pointer" }}
                      />

                      <div className={styles.rewardsFooter}>
                        <div className={styles.rewardsGame}>
                          {reward.game || ""}
                        </div>
                        <div className={styles.rewardsName}>{reward.name}</div>

                        <div className={styles.rewardsCredits}>
                          {/* <span>CREDITS : </span> */}
                          <span>
                            {reward.credits
                              ? reward.credits.toLocaleString()
                              : "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}
      </div>

      {/* ESL GAMES */}
      <div ref={sectionRefs["ESL Games"]} className={styles.weeklyTasksSection}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionHeaderTitle}>Made by ESL</h3>
          <p className={styles.sectionHeaderSubtitle}>
            Play & Earn with ESL Originals
          </p>
        </div>
        {loadingEslGames && <div className={styles.loading}>Loading...</div>}
        {errorEslGames && (
          <div className={styles.error}>Error: {errorEslGames}</div>
        )}
        {!loadingEslGames && !errorEslGames && eslGames.length > 0 && (
          <Swiper
            breakpoints={eslGameBreakpoints}
            className={styles.weeklyTasksSwiper}
            autoplay={{ delay: 2500 }}
            loop={eslGames.length > 1}
          >
            {eslGames
              .filter((game) => game.game_status === 1)
              .map((game) => {
                const gameImage =
                  getDailyTaskImage(game.game, isMobile) || pubgImageDummy;
                return (
                  <SwiperSlide key={game.game_unique_id || game.id}>
                    <div
                      onClick={() =>
                        handleEslGameClick(
                          game.gameId || game.game_unique_id,
                          game.game,
                        )
                      }
                      className={styles.clickableTaskCard}
                      role="button"
                      tabIndex={0}
                      onKeyPress={(e) =>
                        e.key === "Enter" &&
                        handleDailyGameClick(
                          game.gameId || game.game_unique_id,
                          game.game,
                        )
                      }
                    >
                      <div
                        className={styles.eslGametaskCard}
                        style={{ backgroundImage: `url(${gameImage})` }}
                      >
                        {game.game &&
                          game.game.toLowerCase().includes("cannon") && (
                            <button
                              className={styles.infoButton}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleShowInstructions(game.game);
                              }}
                              title="View Game Instructions"
                            >
                              {/* <span
                                  className={styles.infoIcon}
                                >
                                  ?
                                </span> */}
                              <span className={weeklyTournamentStyles.infoText}>
                                How to Play
                              </span>
                            </button>
                          )}
                      </div>
                      {/* <p className={styles.taskTitle}>{game.game}</p> */}
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>
        )}
      </div>

      {/* LEARN WIN */}
      <div ref={sectionRefs["Learn & Win"]} className={styles.learnwinSection}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionHeaderTitle}>Learn and Win</h3>
          <p className={styles.sectionHeaderSubtitle}>
            Test your Gaming mettle
          </p>
        </div>

        <Swiper
          breakpoints={learnwinBreakPoints}
          className={styles.learnwinSwipper}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
        >
          {[gamezAcad1, gamezAcad2, gamezAcad3].map((image, index) => (
            <SwiperSlide key={index}>
              <div
                className={styles.learnwinCard}
                onClick={() =>
                  window.open("https://gamezacademy.pk/", "_blank")
                }
              >
                <div
                  className={styles.learnwinImage}
                  style={{ backgroundImage: `url(${image})` }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Highlights */}
      <div ref={sectionRefs["Highlights"]} className={styles.learnwinSection}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionHeaderTitle}>Highlights</h3>
          <p className={styles.sectionHeaderSubtitle}>
            Tournaments Games Highlights
          </p>
        </div>

        {loadingGameHighlights && (
          <div className={styles.loading}>Loading...</div>
        )}
        {errorGameHighlights && (
          <div className={styles.error}>Error: {errorGameHighlights}</div>
        )}
        {!loadingGameHighlights && !errorGameHighlights && (
          <Swiper
            breakpoints={highlightsBreakPoints}
            className={styles.learnwinSwipper}
            autoplay={{ delay: 2500 }}
            loop={gameHighlightsData.length > 4}
          >
            {gameHighlightsData.map((highlight) => {
              const gameImage = getGameHighlightImage(highlight.game);
              return (
                <SwiperSlide key={highlight.id}>
                  <div
                    className={`${styles.taskCard} ${styles.highlightsCard}`}
                    onClick={() =>
                      navigate(
                        `/game-highlights?gameId=${highlight.gameId}&gameName=${highlight.game}`,
                        "_blank",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className={styles.highlightsImage}
                      style={{ backgroundImage: `url(${gameImage})` }}
                    ></div>
                    {/* <p className={styles.taskTitle}>{highlight.game}</p> */}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>

      <CannonClashInstructions
        isOpen={showInstructions}
        onClose={handleInstructionsClose}
      />

      <PremiumPackagePopup
        isOpen={showPremiumPopup}
        onClose={() => setShowPremiumPopup(false)}
      />
    </>
  );
}

export default Home;
